<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/address"
                saveRoot="/address"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.address">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/address"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'adresse')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette adresse?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'Address',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    address: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Adresse'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'address'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'districtId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'place'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'address',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'place',
                                type: 'text',
                                label: Core.Definition.getDefinition('Local'),
                                value: '',
                            },
                            {
                                id: 'districtId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Région'),
                                value: null,
                                onSelect: function() {}
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/lieu/adresses')
            }
        }
    }
</script>
